import { Injectable, signal } from '@angular/core';

import { User } from './user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly user = signal(new User());

  setUser(user: User) {
    if (user) {
      this.user.set(user);
    }
  }
}
